module.exports = __webpack_public_path__ + "img/support-ticket.2e5a878f.svg";